// Put your main getters here

import _ from 'lodash'

export default {
  doubleCounter: state => {
    return state.counter * 2;
  },
  user: state => {
    return state.user
  },
  groupedLots: state => {
    return _(state.process.markedRows)
                  .groupBy('lot')
                  .map((lot, id) => ({
                    value: parseInt(id),
                    text: _.get(_.find(lot, 'lot_number'), 'lot_number'),
                  }))
                  .value()
  },
  isLoggedIn: state => !!state.token,
  authStatus: state => state.status,

}
